/* istanbul ignore file */
import { ARTIFACT_ID } from 'domain/shared/artifact';
import { ArtifactUploaderInput } from 'domain/shared/artifact/input';

const ArtifactStorageUploaderInput = (props: any) => {
  return <ArtifactUploaderInput {...props} artifactTypeId={ARTIFACT_ID.ARTIFACT_STORAGE_FILE} />;
};

export default ArtifactStorageUploaderInput;
